module.exports = __webpack_public_path__ + "src/assets/img/logo-car-universe.6fb6d693.svg";